(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amaris-bridal-editorial"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('amaris-bridal')){customElements.define('amaris-bridal',class extends HTMLElement{
connectedCallback(){
this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;const date=this.querySelector('[data-ab-date]');const checks=Array.from(this.querySelectorAll('[data-ab-check]'));const key='amaris-bridal-'+this.dataset.key;
this.querySelectorAll('[data-ab-open]').forEach(button=>button.addEventListener('click',()=>{const dialog=document.getElementById(button.dataset.abOpen);if(dialog){dialog.showModal();this.lastTrigger=button}},{signal}));
this.querySelectorAll('dialog.ab__dialog').forEach(dialog=>{dialog.querySelector('[data-ab-close]').addEventListener('click',()=>dialog.close(),{signal});dialog.addEventListener('click',e=>{if(e.target===dialog){const box=dialog.getBoundingClientRect();if(e.clientX<box.left||e.clientX>box.right||e.clientY<box.top||e.clientY>box.bottom)dialog.close()}},{signal});dialog.addEventListener('close',()=>{dialog.querySelectorAll('video').forEach(video=>video.pause());this.lastTrigger?.focus()},{signal})});

const read=k=>{try{return localStorage.getItem(k)}catch{return null}};const save=(k,v)=>{try{localStorage.setItem(k,v)}catch{}};
if(date){const now=new Date();const today=new Date(now.getFullYear(),now.getMonth(),now.getDate());const iso=[now.getFullYear(),String(now.getMonth()+1).padStart(2,'0'),String(now.getDate()).padStart(2,'0')].join('-');date.min=iso;const update=()=>{const parts=date.value.split('-').map(Number);const chosen=parts.length===3?new Date(parts[0],parts[1]-1,parts[2]):null;const days=chosen?Math.round((Date.UTC(chosen.getFullYear(),chosen.getMonth(),chosen.getDate())-Date.UTC(today.getFullYear(),today.getMonth(),today.getDate()))/86400000):NaN;const valid=Number.isFinite(days)&&days>=0;this.querySelector('[data-ab-days]').textContent=valid?String(days):'—';this.querySelector('[data-ab-error]').hidden=!date.value||valid;const active=days>180?0:days>90?1:days>30?2:3;this.querySelectorAll('[data-ab-stage]').forEach((el,i)=>{el.classList.toggle('is-current',valid&&i===active);if(valid&&i===active)el.setAttribute('aria-current','step');else el.removeAttribute('aria-current')});if(valid)save(key+'-date',date.value);else if(!date.value)save(key+'-date','')};const stored=read(key+'-date');if(stored&&stored>=iso)date.value=stored;date.addEventListener('change',update,{signal});update()}
if(checks.length){let stored=[];try{const parsed=JSON.parse(read(key+'-checks')||'[]');if(Array.isArray(parsed))stored=parsed}catch{}checks.forEach(el=>el.checked=stored.includes(el.dataset.abCheck));const update=()=>{const checked=checks.filter(el=>el.checked);this.querySelector('[data-ab-progress]').textContent=checked.length+' / '+checks.length;save(key+'-checks',JSON.stringify(checked.map(el=>el.dataset.abCheck)))};checks.forEach(el=>el.addEventListener('change',update,{signal}));update()}
}
disconnectedCallback(){this.abort?.abort()}
})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amaris-discovery"]) return;
  try {
    
  function amarisCatalogueIntent(raw, previous = null) {
    let q = raw.toLowerCase().trim();
    const followup =
      /^(only|show (?:lower|higher)|cheaper|more expensive|under|below|above|over|between|without|remove|no budget)/.test(
        q
      );
    const intent =
      followup && previous
        ? { ...previous, terms: [...previous.terms] }
        : { terms: [], minPrice: null, maxPrice: null, sort: 'relevance', clarification: null };
    // Match shopping intent to verified collections; keep category and budget filters.
    const collectionAliases = [
      ['on-the-go', 'On The Go', /\b(?:on[\s-]+the[\s-]+go|office[\s-]*wear|work[\s-]*wear|(?:office|work)[\s-]+(?:jewellery|jewelry)|daily|everyday|every[\s-]+day|casual|9[\s-]*to[\s-]*5)(?:[\s-]+(?:wear|jewellery|jewelry))?\b/g],
      ['amaris-bridal-edit', 'Bridal Edit', /\b(?:bridal(?:[\s-]+(?:edit|wear|jewellery|jewelry))?|bride(?:[\s-]+to[\s-]+be)?|wedding[\s-]+(?:day|trousseau)|shaadi(?:[\s-]+(?:wear|jewellery|jewelry))?|dulhan)\b/g],
      ['heritage', 'Heritage', /\b(?:heritage|traditional|ethnic|festive|festival|diwali|wedding[\s-]+guest)(?:[\s-]+(?:wear|jewellery|jewelry|edit))?\b/g],
      ['glitterati', 'Glitterati', /\b(?:glitterati|(?<!cocktail[\s-])party(?:[\s-]+wear)?|red[\s-]+carpet|evening(?:[\s-]+wear)?|glamorous|glam)(?:[\s-]+(?:jewellery|jewelry|edit))?\b/g],
      ['cocktail', 'Cocktail', /\bcocktail(?:[\s-]+(?:party|wear|jewellery|jewelry|edit))?\b/g],
      ['mehendi', 'Mehendi', /\b(?:mehendi|mehndi|henna)(?:[\s-]+(?:ceremony|wear|jewellery|jewelry|edit))?\b/g],
      ['amaris-escape-vacation-edit', 'Vacation Edit', /\b(?:vacation|holiday|resort|beach)(?:[\s-]+(?:wear|jewellery|jewelry|edit))?\b/g],
      ['amaris-signatures', 'AMARIS SIGNATURES', /\b(?:amaris[\s-]+signatures|signature[\s-]+(?:pieces|jewels|jewellery|jewelry))\b/g],
    ];
    const matchedCollections = collectionAliases.filter(([, , pattern]) => {
      pattern.lastIndex = 0;
      const matches = pattern.test(q);
      pattern.lastIndex = 0;
      return matches;
    });
    // Do not silently choose one collection for a query naming multiple occasions.
    if (matchedCollections.length === 1) {
      const [handle, title, pattern] = matchedCollections[0];
      intent.collectionHandle = handle;
      intent.collectionTitle = title;
      q = q.replace(pattern, ' ').trim();
    }

    const specFilters = [];
    q = q.replace(/\b(9|10|14|18|22|24)\s*(?:karats?|carats?|kt|k)\b(?=\s*(?:(?:yellow|white|rose)\s+)?gold)|\b(9|10|14|18|22|24)\s*(?:kt|k)\b/g, (match, a, b, offset) => {
      if (!a && /(?:under|below|above|over|up to|upto|within|between|and|to)\s*$/.test(q.slice(0, offset))) return match;
      specFilters.push({ field: 'purity', value: Number(a || b), operator: 'eq' });
      return ' ';
    });
    q = q.replace(/\b(?:(gold|diamond|gemstone)\s+weight\s*)?(?:(under|below|above|over|at least|up to)\s*)?(\d+(?:\.\d+)?)\s*(grams?|g|cts?|carats?)\b/g, (_, material, bound, value, unit) => {
      const field = /^g/.test(unit) ? 'gold_weight' : material === 'diamond' || (!material && /\bdiamonds?\b/.test(q)) ? 'diamond_weight' : 'gemstone_weight';
      specFilters.push({ field, value: Number(value), operator: /under|below/.test(bound || '') ? 'lt' : /above|over/.test(bound || '') ? 'gt' : bound === 'at least' ? 'gte' : bound === 'up to' ? 'lte' : 'eq' });
      return material ? ` ${material} ` : ' ';
    });
    if (specFilters.length) intent.specFilters = specFilters;
    const amount = (number, unit) =>
      Number(number.replaceAll(',', '')) *
      (/^(lakh|lac|l$)/.test(unit || '')
        ? 100000
        : /^(crore|cr)/.test(unit || '')
        ? 10000000
        : unit === 'k'
        ? 1000
        : 1);
    const number = '(\\d[\\d,]*(?:\\.\\d+)?)\\s*(lakh|lakhs|lac|lacs|l\\b|crore|crores|cr\\b|k\\b)?';
    const range = q.match(
      new RegExp('between\\s*(?:₹|rs\\.?|inr)?\\s*' + number + '\\s*(?:and|to|-)\\s*(?:₹|rs\\.?|inr)?\\s*' + number)
    );
    let clean = q;
    if (range) {
      intent.minPrice = amount(range[1], range[2] || range[4]);
      intent.maxPrice = amount(range[3], range[4] || range[2]);
      clean = clean.replace(range[0], '');
    } else {
      const bound = q.match(
        new RegExp(
          '(under|below|within|up to|upto|less than|budget(?: of)?|max(?:imum)?|above|over|more than)\\s*(?:₹|rs\\.?|inr)?\\s*' +
            number
        )
      );
      if (bound) {
        intent[/above|over|more than/.test(bound[1]) ? 'minPrice' : 'maxPrice'] = amount(bound[2], bound[3]);
        clean = clean.replace(bound[0], '');
      }
    }
    if (/no budget|remove (?:the )?(?:budget|price)|without (?:a )?budget/.test(q)) {
      intent.minPrice = null;
      intent.maxPrice = null;
      clean = clean.replace(/no budget|remove (?:the )?(?:budget|price)|without (?:a )?budget/, '');
    }
    const bestseller = /\b(?:(?:top|best)[\s-]*(?:selling|saleing)|best[\s-]*sellers?)\b/g;
    if (bestseller.test(clean)) {
      intent.sort = 'best_selling';
      clean = clean.replace(bestseller, '');
    }
    const sortCheaper = /cheaper|lower prices|price low/;
    const sortExpensive = /more expensive|higher prices|price high/;
    if (sortCheaper.test(q)) {
      intent.sort = 'price_asc';
      clean = clean.replace(sortCheaper, '');
    }
    if (sortExpensive.test(q)) {
      intent.sort = 'price_desc';
      clean = clean.replace(sortExpensive, '');
    }
    // Strip generic follow-up control prefixes so they don't leak into free text.
    clean = clean.replace(/^\s*(only|show)\s*/, '');

    const subtypes = [
      ['stud', /\bstuds?\b/], ['hoop', /\bhoops?\b/], ['jhumka', /\bjhumkas?\b/],
      ['chandbali', /\bchandbalis?\b/], ['earcuff', /\bear\s?cuffs?\b/], ['earbar', /\bear\s?bars?\b/],
      ['choker', /\bchokers?\b/], ['pendant', /\bpendants?\b/], ['bangle', /\bbangles?\b/]
    ].filter(([,re]) => re.test(clean)).map(([term]) => term);
    intent.subtypeTerms = followup ? (subtypes.length ? subtypes : intent.subtypeTerms || []) : subtypes;

    const groups = [
      ['bridal', /\b(?:bridal|bride|wedding)\b/],
      ['polki', /\bpolki\b/],
      ['kundan', /\bkundan\b/],
      ['earrings', /\b(?:earrings?|studs?|hoops?|ear\s?cuffs?|ear\s?bars?|chandbalis?|jhumkas?)\b/],
      ['ring', /\brings?\b/],
      ['necklace', /\b(?:necklaces?|chokers?|pendants?)\b/],
      ['bracelet', /\b(?:bracelets?|bangles?)\b/],
      ['emerald', /\bemeralds?\b/],
      ['diamond', /\bdiamonds?\b/],
      ['ruby', /\brub(?:y|ies)\b/],
      ['sapphire', /\bsapphires?\b/],
      ['pearl', /\bpearls?\b/],
      ['yellow gold', /\byellow gold\b/],
      ['white gold', /\bwhite gold\b/],
      ['rose gold', /\brose gold\b/],
      ['gold', /\bgold\b/],
      ['tanzanite', /\btanzanites?\b/],
      ['tourmaline', /\btourmalin(?:e)?s?\b/],
      ['amethyst', /\bamethysts?\b/],
      ['aquamarine', /\baquamarines?\b/],
      ['topaz', /\btopaz\b/],
      ['opal', /\bopals?\b/],
      ['garnet', /\bgarnets?\b/],
      ['citrine', /\bcitrines?\b/],
      ['peridot', /\bperidots?\b/],
      ['brooch', /\bbrooch(?:es)?\b/],
      ['tikka', /\b(?:maang\s*tikkas?|mang\s*tikkas?|tikkas?)\b/],
    ];

        const found = groups
      .filter(([, re]) => re.test(clean))
      .map(([term]) => term)
      .filter((term) => term !== 'gold' || !/\b(?:yellow|white|rose) gold\b/.test(clean));

    if (followup && found.some((t) => t.includes('gold')))
      intent.descriptiveTerms = (intent.descriptiveTerms || []).filter((t) => !t.includes('gold'));

    // Strip every matched category/gem/metal phrase out of the text so whatever
    // remains is genuinely "extra" vocabulary — product-line names (Mor Bagh),
    // unlisted gemstones (tourmaline), style words (rosette) — not just words
    // that happened to also match a known category.
    let residual = clean;
    groups.forEach(([, re]) => {
      residual = residual.replace(new RegExp(re.source, 'g' + re.flags.replace('g', '')), ' ');
    });

    const stop = new Set(
      'a an the for with in of and to show me some something any my i want need looking please jewellery jewelry product products piece pieces only first last higher lower cheaper expensive price prices'.split(
        ' '
      )
    );
    const freeText = residual
      .replace(/[^\p{L}\p{N}\s]/gu, ' ')
      .split(/\s+/)
      .filter((t) => t && !stop.has(t))
      .slice(0, 8);

    // Category terms (earrings/ring/necklace/bracelet) stay strict/required.
    // Everything else recognized (bridal, polki, gold, etc.) plus leftover free
    // text (product-line names, unlisted gems, style words) is "descriptive" —
    // these should broaden the search (match ANY of them), not require ALL.
    const categoryWords = ['earrings', 'ring', 'necklace', 'bracelet', 'brooch', 'tikka'];
    const categoryOnly = found.filter((t) => categoryWords.includes(t));
    const descriptiveFound = found.filter((t) => !categoryWords.includes(t));
    const descriptive = [...new Set([...descriptiveFound, ...freeText])];

    intent.categoryTerms = followup
      ? (categoryOnly.length ? categoryOnly : intent.categoryTerms || [])
      : categoryOnly;
    intent.descriptiveTerms = followup
      ? [...new Set([...(intent.descriptiveTerms || []), ...descriptive])]
      : descriptive;
    // Kept for amarisMatchesCategory / amarisMatchesOccasionTags, which read from intent.terms.
    intent.terms = [...new Set([...intent.categoryTerms, ...intent.descriptiveTerms])];

    if (intent.minPrice !== null && intent.maxPrice !== null && intent.minPrice > intent.maxPrice)
      throw new Error('error');
    return intent;
  }

  function amarisRelevanceScore(product, intent) {
    const descriptive = intent.descriptiveTerms || [];
    if (!descriptive.length) return 0;
    const tagText = Array.isArray(product.tags)
      ? product.tags.join(' ')
      : typeof product.tags === 'string'
      ? product.tags
      : '';
    const haystack = `${product.title || ''} ${tagText} ${amarisSpecText(product)}`.toLowerCase();
    const phrase = descriptive.join(' ');
    let score = haystack.includes(phrase) ? 10 : 0; // exact adjacent phrase — "exact product" bonus
    score += descriptive.reduce((sum, term) => sum + (haystack.includes(term) ? 3 : 0), 0);
    return score;
  }

  function amarisCatalogueProducts(payload, intent, currency) {
    if (payload.currency !== currency || !Array.isArray(payload.products)) throw new Error('error');
    const products = [];
    for (const p of payload.products) {
      if (!amarisMatchesCategory(p, intent) || !amarisMatchesOccasionTags(p, intent)) continue;
      const productFilters = {...intent, specFilters:(intent.specFilters || []).filter(f => f.field !== 'purity' || !p.variants.some(v => /\b(?:9|10|14|18|22|24)\s*k(?:t)?\b/i.test(v.title || '')))};
      if (!amarisMatchesSpecs(p, productFilters)) continue;
      if (!amarisMatchesAttributes(p, intent)) continue;
      const variants = p.variants
        .filter(
          (v) =>
            v.available && amarisMatchesVariant(v, p, intent) &&
            Number(v.price) > 0 &&
            (intent.minPrice === null || Number(v.price) / 100 >= intent.minPrice) &&
            (intent.maxPrice === null || Number(v.price) / 100 <= intent.maxPrice)
        )
        .sort((a, b) => Number(a.price) - Number(b.price));
      if (!variants.length) continue;
      products.push({
        id: String(p.id),
        handle: p.handle,
        title: p.title,
        variant: String(variants[0].id),
        price: String(Number(variants[0].price) / 100),
        currency,
        image: variants[0].image || p.image,
        alt: p.title,
        specs: p.specs || null,
        badge: typeof p.badge === 'string' && /^best[\s-]*sellers?$/i.test(p.badge.trim()) ? 'Bestseller' : null,
        relevance: amarisRelevanceScore(p, intent),
      });
    }
    if (intent.sort === 'relevance' && (intent.descriptiveTerms || []).length) {
      products.sort((a, b) => b.relevance - a.relevance);
    } else if (['price_asc', 'price_desc'].includes(intent.sort)) {
      products.sort((a, b) => (Number(a.price) - Number(b.price)) * (intent.sort === 'price_desc' ? -1 : 1));
    }
    return products;
  }

  function amarisMatchesCategory(product, intent) {
    const categories = {
      brooch: /\bbrooch(?:es)?\b/i,
      tikka: /\b(?:tikkas?|maang|mang|matha|headpiece)\b/i,
      earrings: /\b(?:earrings?|studs?|hoops?|ear\s?cuffs?|ear\s?bars?|chandbalis?|jhumkas?)\b/i,
      ring: /\brings?\b/i,
      necklace: /\b(?:necklaces?|chokers?|pendants?)\b/i,
      bracelet: /\b(?:bracelets?|bangles?|cuffs?|palmcuffs?)\b/i,
    };
    const subtypeLabel = `${product.title || ''} ${product.product_type || product.type || ''}`;
    const subtypePatterns = {stud:/\bstuds?\b/i,hoop:/\bhoops?\b/i,jhumka:/\bjhumkas?\b/i,chandbali:/\bchandbalis?\b/i,earcuff:/\bear\s?cuffs?\b/i,earbar:/\bear\s?bars?\b/i,choker:/\bchokers?\b/i,pendant:/\bpendants?\b/i,bangle:/\bbangles?\b/i};
    if ((intent.subtypeTerms || []).length && !intent.subtypeTerms.some(term => subtypePatterns[term]?.test(subtypeLabel))) return false;
    const requested = intent.terms.filter((term) => categories[term]);
    if (!requested.length) return true;
    const tagText = Array.isArray(product.tags)
    ? product.tags.join(' ')
    : typeof product.tags === 'string'
    ? product.tags
    : '';
    // Include tags, not just title/product_type — Shopify's own search already
  // matched this product via tags/vendor/description, so re-checking against
  // title + product_type alone was silently dropping valid results back out.
    const typed = String(product.product_type || product.type || '');
    const label = `${product.title || ''} ${typed}`;
    const categoryLabel = Object.values(categories).some(re => re.test(typed)) ? typed : Object.values(categories).some(re => re.test(label)) ? label : tagText;
    if (requested.includes('earrings') && /\b(?:tikkas?|maang|mang|matha|headpiece)\b/i.test(label)) return false;
    return requested.some((term) => categories[term].test(categoryLabel));
  }

  function amarisMatchesOccasionTags(product, intent) {
    if (!intent.terms.includes('bridal')) return true;
    const tags = Array.isArray(product.tags)
      ? product.tags
      : typeof product.tags === 'string'
      ? product.tags.split(',')
      : [];
    return tags.some((tag) => {
      const normalized = String(tag).toLowerCase().replace(/[_-]+/g, ' ').trim();
      return /\b(?:bridal|bride|wedding)\b/.test(normalized) && !/\b(?:non|not|no)\b/.test(normalized);
    });
  }

function amarisSpecText(product) {
  const s = product.specs || {};
  const metal = String(s.metal_quality || '').replace(/G(\d+)([YWRK])/gi, (_, n, color) => `${n} karat ${ {Y:'yellow ',W:'white ',R:'rose ',K:''}[color.toUpperCase()] }gold`);
  return [metal, s.stock_status, s.cutline, ...(s.stones || []).map(stone => stone.name), Number.parseFloat(s.gold_weight) > 0 ? 'gold' : '', Number.parseFloat(s.diamond_weight) > 0 ? 'diamond' : ''].filter(Boolean).join(' ').toLowerCase();
}
function amarisMatchesSpecs(product, intent) {
  const s = product.specs || {};
  return (intent.specFilters || []).every(filter => {
    if (filter.field === 'purity') return new RegExp(`(?:g|\\b)${filter.value}(?:[ywrk]\\b|\\s*(?:k|kt|karat|carat))`, 'i').test(String(s.metal_quality || ''));
    const raw = s[filter.field];
    let value;
    if (raw && typeof raw === 'object') {
      const unit = String(raw.unit || '').toLowerCase();
      if (!['g','kg','mg','ct','cts','carat','carats'].includes(unit)) return false;
      value = Number(raw.value) * (unit === 'kg' ? 1000 : unit === 'mg' ? .001 : 1);
      if (filter.field === 'gold_weight' !== ['g','kg','mg'].includes(unit)) return false;
    } else {
      const match = String(raw ?? '').trim().match(/^(\d+(?:\.\d+)?)\s*(g|grams?|ct|cts|carats?)?$/i);
      if (!match) return false;
      if (match[2] && (filter.field === 'gold_weight') !== /^g/i.test(match[2])) return false;
      value = Number(match[1]);
    }
    if (!Number.isFinite(value) || value <= 0) return false;
    return filter.operator === 'lt' ? value < filter.value : filter.operator === 'gt' ? value > filter.value : filter.operator === 'gte' ? value >= filter.value : filter.operator === 'lte' ? value <= filter.value : Math.abs(value-filter.value) < .00001;
  });
}

  function amarisMatchesAttributes(product, intent) {
    const s = product.specs || {};
    const normalize = text => String(text || '').toLowerCase().replace(/\btourmalins?\b/g, 'tourmaline').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
    const tags = Array.isArray(product.tags) ? product.tags.join(' ') : product.tags || '';
    const text = normalize(`${product.title || ''} ${tags} ${amarisSpecText(product)}`);
    const stones = normalize((s.stones || []).map(stone => stone.name || '').join(' '));
    const gems = new Set(['emerald','ruby','sapphire','pearl','tanzanite','tourmaline','amethyst','aquamarine','topaz','opal','garnet','citrine','peridot']);
    const contains = (haystack, term) => new RegExp(`(?:^|\\s)${term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(?:s|ies)?(?:\\s|$)`, 'i').test(haystack);
    return (intent.descriptiveTerms || []).every(term => {
      if (term === 'bridal') return amarisMatchesOccasionTags(product, intent);
      if (gems.has(term)) return contains(stones || text, term) || (term === 'ruby' && contains(stones || text, 'rubies'));
      if (term === 'diamond') return Number.parseFloat(s.diamond_weight?.value ?? s.diamond_weight) > 0 || contains(stones || text, term);
      if (term.includes('gold')) return (product.variants || []).some(v => /\bgold\b/i.test(v.title || '')) || contains(normalize(amarisSpecText(product)) || text, term);
      return contains(text, normalize(term)) || text.split(' ').some(word => word.startsWith(normalize(term)));
    });
  }

  function amarisMatchesVariant(variant, product, intent) {
    const title = String(variant.title || '').toLowerCase();
    const hasMetalOptions = (product.variants || []).some(v => /\bgold\b/i.test(v.title || ''));
    if (hasMetalOptions && (intent.descriptiveTerms || []).filter(t => t.includes('gold')).some(t => !title.includes(t))) return false;
    const hasPurityOptions = (product.variants || []).some(v => /\b(?:9|10|14|18|22|24)\s*k(?:t)?\b/i.test(v.title || ''));
    if (hasPurityOptions && (intent.specFilters || []).filter(f => f.field === 'purity').some(f => !new RegExp(`\\b${f.value}\\s*k(?:t)?\\b`, 'i').test(title))) return false;
    return true;
  }
  if (!customElements.get('amaris-discovery')) {
    customElements.define(
      'amaris-discovery',
      class extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;
          this.bound = true;
          this.listeners = new AbortController();
          const on = (target, event, fn, extra = {}) =>
            target.addEventListener(event, fn, { signal: this.listeners.signal, ...extra });
          this.dialog = this.querySelector('dialog');
          this.input = this.querySelector('input');
          this.form = this.querySelector('form');
          this.grid = this.querySelector('[data-results-grid]');
          this.status = this.querySelector('.ad-status');
          this.autocomplete = this.querySelector('.ad-autocomplete');
          this.suggestSequence = 0;
          this.searchCache = new Map();
          on(this.input, 'input', (e) => {
            if (!e.isComposing) this.queueSuggestions();
          });
          on(this.input, 'compositionend', () => this.queueSuggestions());
          on(this.input, 'keydown', (e) => {
            if (e.key === 'Enter' && !e.isComposing && e.keyCode !== 229) {
              e.preventDefault();
              const query = this.input.value.trim();
              if (query) {
                const intent = amarisCatalogueIntent(query);
                if (intent.collectionHandle) {
                  if (!intent.categoryTerms.length && !intent.descriptiveTerms.length && !intent.specFilters?.length && intent.minPrice === null && intent.maxPrice === null && intent.sort === 'relevance') {
                    const root = this.dataset.root.replace(/\/?$/, '/');
                    window.location.assign(new URL(`${root}collections/${intent.collectionHandle}`, window.location.origin).href);
                  } else {
                    this.run(query);
                  }
                  return;
                }
                const url = new URL(this.form.action, window.location.origin);
                url.searchParams.set('q', query);
                url.searchParams.set('type', 'product');
                url.searchParams.set('options[prefix]', 'last');
                window.location.assign(url.href);
              }
              return;
            }
            if (e.key === 'ArrowDown' && !this.autocomplete.hidden) {
              e.preventDefault();
              this.autocomplete.querySelector('a,button')?.focus();
            }
            if (e.key === 'Escape' && !this.autocomplete.hidden) {
              e.preventDefault();
              e.stopPropagation();
              this.clearSuggestions();
            }
          });
          on(this.autocomplete, 'keydown', (e) => {
            const items = [...this.autocomplete.querySelectorAll('a,button')];
            const index = items.indexOf(document.activeElement);
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
              e.preventDefault();
              const next = index + (e.key === 'ArrowDown' ? 1 : -1);
              if (next < 0) this.input.focus();
              else items[Math.min(next, items.length - 1)]?.focus();
            }
            if (e.key === 'Escape') {
              e.preventDefault();
              e.stopPropagation();
              this.clearSuggestions();
              this.input.focus();
            }
          });
          const imageOpen = this.querySelector('[data-image-open]');
          if (imageOpen) {
            on(imageOpen, 'click', () => this.openImageSearch());
            on(this.querySelector('[data-image-close]'), 'click', () => {
              this.cancel();
              this.querySelector('[data-image-panel]').hidden = true;
              this.classList.remove('ad-image-mode');
              this.querySelector('.ad-suggestions').hidden = !this.querySelector('.ad-results').hidden;
              this.querySelector('.ad-trending').hidden = !this.querySelector('.ad-results').hidden;
              this.input.focus();
            });
            const picker = this.querySelector('[data-image-file]');
            for (const button of this.querySelectorAll('[data-image-choose], [data-image-replace]')) {
              on(button, 'click', () => picker.click());
            }
            on(picker, 'change', async (e) => {
              const file = e.target.files[0];
              if (file) await this.searchImageFile(file);
              e.target.value = '';
            });
            const drop = this.querySelector('[data-image-drop]');
            on(drop, 'dragover', (e) => { e.preventDefault(); drop.classList.add('is-dragging'); });
            on(drop, 'dragleave', () => drop.classList.remove('is-dragging'));
            on(drop, 'drop', (e) => {
              e.preventDefault(); drop.classList.remove('is-dragging');
              const file = e.dataTransfer?.files[0];
              if (file) this.searchImageFile(file);
            });
            for (const sample of this.querySelectorAll('[data-image-sample]')) {
              on(sample, 'click', async () => {
                this.cancel();
                const sequence = this.sequence;
                const controller = new AbortController();
                this.sampleRequest = controller;
                const timer = setTimeout(() => controller.abort(), 15000);
                try {
                  const url = new URL(sample.dataset.imageSample, location.origin);
                  if (url.protocol !== 'https:' || (url.origin !== location.origin && url.hostname !== 'cdn.shopify.com')) throw new Error('Invalid image');
                  const response = await fetch(url, { signal: controller.signal });
                  if (!response.ok) throw new Error('Image unavailable');
                  const blob = await response.blob();
                  if (sequence === this.sequence && this.dialog.open) await this.searchImageFile(blob);
                } catch (error) {
                  if (sequence === this.sequence && error.name !== 'AbortError') this.querySelector('[data-image-error]').textContent = 'This sample could not load. Try uploading an image.';
                } finally { clearTimeout(timer); }
              });
            }
          }
          this.history = [];
          this.sequence = 0;
          this.placeholder = this.input.placeholder;
          this.messages = Object.fromEntries(
            [...this.querySelectorAll('[data-key]')].map((el) => [el.dataset.key, el.textContent])
          );
          on(this.querySelector('[data-close]'), 'click', () => this.dialog.close());
          on(this.dialog, 'click', (e) => {
            if (e.target === this.dialog) {
              const r = this.dialog.getBoundingClientRect();
              if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)
                this.dialog.close();
            }
          });
          on(this.dialog, 'close', () => {
            this.cancel();
            document.body.style.overflow = this.oldOverflow || '';
            this.returnFocus?.focus();
          });
          on(this.form, 'submit', (e) => {
            e.preventDefault();
            this.run(this.input.value);
          });
          on(this.querySelector('[data-reset]'), 'click', () => this.reset());
          this.querySelectorAll('[data-suggest]').forEach((button) =>
            on(button, 'click', () => {
              this.input.value = button.textContent;
              this.run(button.textContent);
            })
          );
          if (this.dataset.header === 'true')
            on(
              document,
              'click',
              (e) => {
                if (e.target.closest('search-popdown[data-popdown-in-header] [data-popdown-toggle]')) {
                  e.preventDefault();
                  e.stopImmediatePropagation();
                  this.open();
                }
              },
              { capture: true }
            );
        }
        disconnectedCallback() {
          if (this.dialog?.open) {
            this.dialog.close();
            document.body.style.overflow = this.oldOverflow || '';
          }
          this.cancel();
          this.listeners?.abort();
          this.bound = false;
        }
        open() {
          if (this.dialog.open) return;
          this.returnFocus = document.activeElement;
          this.oldOverflow = document.body.style.overflow;
          this.dialog.showModal();
          document.body.style.overflow = 'hidden';
          this.input.focus();
        }
        cancel() {
          this.sampleRequest?.abort();
          this.clearSuggestions();
          this.sequence++;
          this.request?.abort();
          this.form?.querySelector('[type=submit]').removeAttribute('disabled');
          this.grid?.removeAttribute('aria-busy');
          if (this.status?.textContent === this.messages?.loading) this.status.textContent = '';
        }
        reset() {
          this.cancel();
          this.history = [];
          const imagePanel = this.querySelector('[data-image-panel]');
          if (imagePanel) imagePanel.hidden = true;
          this.classList.remove('ad-image-mode');
          this.lastIntent = null;
          this.grid.replaceChildren();
          this.status.textContent = '';
          this.querySelector('.ad-context').replaceChildren();
          this.querySelector('.ad-results').hidden = true;
          this.querySelector('.ad-refinements').hidden = true;
          this.querySelector('.ad-suggestions').hidden = false;
          this.querySelector('.ad-trending').hidden = false;
          this.input.value = '';
          this.input.placeholder = this.placeholder;
          this.input.focus();
        }
        clearSuggestions() {
          clearTimeout(this.suggestTimer);
          this.suggestRequest?.abort();
          this.suggestSequence++;
          this.autocomplete?.replaceChildren();
          if (this.autocomplete) this.autocomplete.hidden = true;
        }
        cachedSearch(key) {
          const entry = this.searchCache.get(key);
          if (entry && Date.now() - entry.time < 60000) return entry.data;
          this.searchCache.delete(key);
        }
        cacheSearch(key, data) {
          this.searchCache.delete(key);
          this.searchCache.set(key, { time: Date.now(), data });
          if (this.searchCache.size > 30) this.searchCache.delete(this.searchCache.keys().next().value);
          return data;
        }
        openImageSearch() {
          this.cancel();
          this.querySelector('[data-image-panel]').hidden = false;
          this.classList.add('ad-image-mode');
          this.querySelector('[data-image-drop]').hidden = false;
          this.querySelector('[data-image-selected]').hidden = true;
          this.querySelector('[data-image-preview]').removeAttribute('src');
          this.querySelector('[data-image-error]').textContent = '';
          this.querySelector('.ad-results').hidden = true;
          this.querySelector('.ad-suggestions').hidden = true;
          this.querySelector('.ad-trending').hidden = true;
          this.querySelector('[data-image-samples]').hidden = !this.querySelector('[data-image-sample]');
          this.querySelector('[data-image-choose]').focus();
        }
        async searchImageFile(file) {
          this.cancel();
          const sequence = this.sequence;
          const error = this.querySelector('[data-image-error]');
          error.textContent = '';
          if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 2000000 || !file.size) {
            error.textContent = 'Choose a JPG, PNG or WebP photo under 2 MB.';
            return;
          }
          try {
            const image = await new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(file);
            });
            if (sequence !== this.sequence || !this.dialog.open) return;
            this.querySelector('[data-image-preview]').src = image;
            this.querySelector('[data-image-selected]').hidden = false;
            this.querySelector('[data-image-drop]').hidden = true;
            this.querySelector('[data-image-samples]').hidden = true;
            await this.run('Find similar jewellery in the Amaris catalogue', image);
          } catch {
            if (sequence === this.sequence) error.textContent = 'Could not read this photo. Please try another.';
          }
        }
        queueSuggestions() {
          clearTimeout(this.suggestTimer);
          this.suggestRequest?.abort();
          this.suggestSequence++;
          this.request?.abort();
          this.sequence++;
          this.form.querySelector('[type=submit]').disabled = false;
          this.querySelector('.ad-body').scrollTop = 0;
          this.grid.hidden = true;
          this.status.textContent = '';
          this.querySelector('.ad-results').hidden = true;
          this.querySelector('.ad-refinements').hidden = true;
          const query = this.input.value.trim();
          this.querySelector('.ad-trending').hidden = query.length >= 3 || !this.querySelector('.ad-results').hidden;
          if ([...query].length < 3 || query.length > 400) { this.clearSuggestions(); return; }
          this.autocomplete.hidden = false;
          this.autocomplete.setAttribute('aria-busy', 'true');
          this.autocomplete.replaceChildren();
          const sequence = this.suggestSequence;
          this.suggestTimer = setTimeout(() => this.fetchSuggestions(query, sequence), 300);
        }
        async fetchSuggestions(query, sequence) {
          const controller = new AbortController();
          this.suggestRequest = controller;
          const timeout = setTimeout(() => controller.abort(), 35000);
          try {
            const data = await this.catalogueSearch(query, controller.signal);
            if (sequence !== this.suggestSequence || this.input.value.trim() !== query || !this.dialog.open) return;
            const fragment = document.createDocumentFragment();
            for (const product of data.products.slice(0, 12)) {
              const target = new URL(
                `${this.dataset.root}products/${product.handle}?variant=${product.variant}`,
                location.origin
              );
              if (target.origin !== location.origin || !target.pathname.includes('/products/')) continue;
              const link = document.createElement('a');
              link.href = target.href;
              link.className = 'ad-card';
              const imageBox = document.createElement('div');
              imageBox.className = 'ad-card-image';
              imageBox.textContent = '✧';
              const source = product.featured_image?.url || product.image;
              if (source) {
                const imageURL = new URL(source, location.origin);
                if (
                  imageURL.protocol === 'https:' &&
                  (imageURL.origin === location.origin || imageURL.hostname === 'cdn.shopify.com')
                ) {
                  imageURL.searchParams.set('width', '400');
                  const image = document.createElement('img');
                  image.src = imageURL.href;
                  image.alt = product.featured_image?.alt || product.title;
                  image.width = 400;
                  image.height = 400;
                  image.loading = 'lazy';
                  imageBox.replaceChildren(image);
                }
              }
              this.appendProductBadge(imageBox, product);
              const title = document.createElement('h4');
              title.textContent = product.title;
              link.append(imageBox, title);
              if (product.price !== null && product.price !== undefined && Number.isFinite(Number(product.price))) {
                const price = document.createElement('p');
                price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
                  style: 'currency',
                  currency: this.dataset.currency,
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                }).format(Number(product.price));
                link.append(price);
              }
              fragment.append(link);
            }
            const search = document.createElement('button');
            search.type = 'button';
            search.classList.toggle('ad-no-matches', !data.products.length);
            search.textContent = data.products.length ? `View all ${data.products.length} matching jewels` : `No matching jewels — search “${query}”`;
            search.addEventListener('click', () => this.run(query), { signal: this.listeners.signal });
            fragment.append(search);
            this.autocomplete.replaceChildren(fragment);
            this.autocomplete.hidden = false;
            this.autocomplete.scrollTop = 0;
            this.autocomplete.removeAttribute('aria-busy');
          } catch (error) {
            if (sequence === this.suggestSequence) {
              this.autocomplete.removeAttribute('aria-busy');
              this.autocomplete.textContent = 'Suggestions could not load. Press Search to retry.';
            }
          } finally {
            clearTimeout(timeout);
          }
        }
        async catalogueSearch(query, signal) {
          const intent = amarisCatalogueIntent(query, this.lastIntent);
          const root = this.dataset.root.replace(/\/?$/, '/');
          const url = new URL(`${root}collections/${intent.collectionHandle || 'all'}`, location.origin);
          url.searchParams.set('section_id', 'amaris-catalogue-index');
          url.searchParams.set('amaris_index', '2');
          url.searchParams.set('sort_by', intent.sort === 'best_selling' ? 'best-selling' : 'title-ascending');
          const key = `index:${this.dataset.currency}:${url.href}`;
          let payload = this.cachedSearch(key);
          if (!payload) {
            const readPage = async page => {
              const pageURL = new URL(url); pageURL.searchParams.set('page', String(page));
              const response = await fetch(pageURL, { signal });
              if (!response.ok) throw new Error('error');
              const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
              const json = doc.querySelector('[data-amaris-catalogue]');
              if (!json) throw new Error('error');
              const data = JSON.parse(json.textContent);
              if (data.currency !== this.dataset.currency || !Array.isArray(data.products)) throw new Error('error');
              return data;
            };
            const first = await readPage(1);
            const pages = Number(first.pages);
            if (!Number.isInteger(pages) || pages < 1 || pages > 100) throw new Error('error');
            const products = [...first.products];
            for (let page = 2; page <= pages; page += 4) {
              const batch = await Promise.all(Array.from({length: Math.min(4, pages - page + 1)}, (_, i) => readPage(page + i)));
              for (const data of batch) products.push(...data.products);
            }
            if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
            const unique = [...new Map(products.map(p => [String(p.id), p])).values()];
            payload = this.cacheSearch(key, {currency:first.currency, products:unique});
          }
          return {intent, products:amarisCatalogueProducts(payload, intent, this.dataset.currency), incomplete:false, catalogue:true};
        }
        appendProductBadge(imageBox, product) {
          if (product.badge !== 'Bestseller') return;
          const badge = document.createElement('span');
          badge.className = 'ad-product-badge';
          badge.textContent = 'Bestseller';
          imageBox.append(badge);
        }
        async run(raw, image = null) {
          const query = raw.trim();
          if (!query || query.length > 400) return;
          this.cancel();
          const sequence = this.sequence;
          this.request = new AbortController();
          const controller = this.request;
          const timer = setTimeout(() => controller.abort(), 35000);
          this.form.querySelector('[type=submit]').disabled = true;
          this.grid.replaceChildren();
          this.querySelector('.ad-body').scrollTop = 0;
          this.grid.hidden = false;
          this.grid.setAttribute('aria-busy', 'true');
          this.querySelector('.ad-suggestions').hidden = true;
          this.querySelector('.ad-trending').hidden = true;
          this.querySelector('.ad-refinements').hidden = true;
          this.querySelector('.ad-results').hidden = false;
          this.querySelector('.ad-context').replaceChildren();
          this.status.textContent = this.messages.loading;
          try {
            let data;
            if (this.dataset.aiEnabled === 'true' && !amarisCatalogueIntent(query, this.lastIntent).collectionHandle) {
              try {
                const endpoint = new URL(this.dataset.endpoint, location.origin);
                if (endpoint.origin !== location.origin || !endpoint.pathname.startsWith('/apps/'))
                  throw new Error('error');
                const response = await fetch(endpoint, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  signal: controller.signal,
                  body: JSON.stringify({
                    query,
                    history: this.history,
                    country: this.dataset.country,
                    currency: this.dataset.currency,
                    ...(image ? { image } : {}),
                  }),
                });
                if (!response.ok) throw new Error('error');
                data = await response.json();
                if (!Array.isArray(data.products) || !Array.isArray(data.intent?.terms)) throw new Error('error');
              } catch (error) {
                if (controller.signal.aborted || image) throw error;
              }
            }
            if (image && !data) throw new Error('error');
            if (!data) data = await this.catalogueSearch(query, controller.signal);
            if (sequence !== this.sequence) return;
            if (!Array.isArray(data.products) || !Array.isArray(data.intent?.terms)) throw new Error('error');
            if (data.intent.clarification) {
              this.status.textContent = data.intent.clarification;
              return;
            }
            this.history = [...this.history, query].slice(-6);
            this.lastIntent = data.intent;
            this.input.placeholder = this.placeholder;
            const context = this.querySelector('.ad-context');
            const labels = [...data.intent.terms];
            if (data.intent.sort === 'best_selling') labels.unshift('Best selling');
            for (const filter of data.intent.specFilters || []) {
              const units = filter.field === 'purity' ? 'karat gold' : filter.field === 'gold_weight' ? 'g gold' : filter.field === 'diamond_weight' ? 'ct diamond' : 'ct gemstone';
              labels.push(`${{eq:'',lt:'< ',gt:'> ',lte:'≤ ',gte:'≥ '}[filter.operator]}${filter.value} ${units}`);
            }
            const format = (n) =>
              new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
                style: 'currency',
                currency: this.dataset.currency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
              }).format(n);
            if (data.intent.minPrice !== null) labels.push(`≥ ${format(data.intent.minPrice)}`);
            if (data.intent.maxPrice !== null) labels.push(`≤ ${format(data.intent.maxPrice)}`);
            labels.forEach((label) => {
              const chip = document.createElement('span');
              chip.textContent = label;
              context.append(chip);
            });
            const fragment = document.createDocumentFragment();
            data.products.forEach((product) => {
              if (
                product.currency !== this.dataset.currency ||
                !/^[a-z0-9-]+$/.test(product.handle) ||
                !/^\d+$/.test(product.variant) ||
                !Number.isFinite(Number(product.price))
              )
                throw new Error('error');
              const card = document.createElement('a');
              card.className = 'ad-card';
              card.href = `${this.dataset.root}products/${product.handle}?variant=${product.variant}`;
              const imageBox = document.createElement('div');
              imageBox.className = 'ad-card-image';
              imageBox.textContent = '✧';
              if (product.image) {
                const url = new URL(product.image);
                if (
                  url.protocol === 'https:' &&
                  (url.hostname === 'cdn.shopify.com' || url.origin === location.origin)
                ) {
                  url.searchParams.set('width', '500');
                  const image = document.createElement('img');
                  image.src = url.href;
                  image.alt = product.alt || product.title;
                  image.loading = 'lazy';
                  image.width = 500;
                  image.height = 500;
                  imageBox.replaceChildren(image);
                }
              }
              const title = document.createElement('h4');
              title.textContent = product.title;
              const price = document.createElement('p');
              price.textContent = format(Number(product.price));
              this.appendProductBadge(imageBox, product);
              card.append(imageBox, title, price);
              fragment.append(card);
            });
            this.grid.replaceChildren(fragment);
            this.status.textContent = !data.products.length ? this.messages.empty : `${data.products.length} matching jewels`;
            this.querySelector('.ad-refinements').hidden = !data.products.length;
          } catch (error) {
            if (sequence === this.sequence)
              this.status.textContent = this.messages[error.message] || this.messages.error;
          } finally {
            clearTimeout(timer);
            if (sequence === this.sequence) {
              this.form.querySelector('[type=submit]').disabled = false;
              this.grid.removeAttribute('aria-busy');
              if (this.dialog.open) this.input.focus();
            }
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
if (!customElements.get('amaris-collection-toggle')) {
  customElements.define('amaris-collection-toggle', class extends HTMLElement {
    connectedCallback() {
      this.grid = document.getElementById('AmarisProducts-' + this.dataset.sectionId);
      this.button = this.querySelector('button');
      if (!this.grid || !this.button || this.ready) return;
      this.ready = true;
      this.expanded = false;
      this.media = matchMedia('(max-width: 767px)');
      this.onMediaChange = () => this.update();
      this.media.addEventListener('change', this.onMediaChange);
      this.gridObserver = new MutationObserver(() => this.update());
      this.gridObserver.observe(this.grid, {childList:true});
      this.update();
      this.button.addEventListener('click', async () => {
        const collapse = this.expanded;
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        try {
          while (!collapse && this.dataset.next) {
            const url = new URL(this.dataset.next, location.origin);
            url.searchParams.set('section_id', this.dataset.sectionId);
            const response = await fetch(url);
            if (!response.ok) throw new Error('Collection request failed');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const grid = doc.getElementById(this.grid.id);
            if (!grid) throw new Error('Collection grid missing');
            this.grid.append(...Array.from(grid.children));
            const toggle = doc.querySelector('amaris-collection-toggle');
            this.dataset.next = toggle ? toggle.dataset.next || '' : '';
          }
          this.expanded = !collapse;
          this.update();
          if (collapse) this.button.scrollIntoView({block: 'center', behavior: 'instant'});
        } catch (error) {
          this.expanded = false;
          this.update();
          console.error(error);
        } finally {
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      });
    }
    disconnectedCallback() {
      if (this.media && this.onMediaChange) this.media.removeEventListener('change', this.onMediaChange);
      if (this.gridObserver) this.gridObserver.disconnect();
    }
    update() {
      const limit = 11;
      this.grid.querySelectorAll('.amaris-grid-closing').forEach(item => item.classList.remove('amaris-grid-closing'));
      let count = 0;
      Array.from(this.grid.children).forEach(item => {
        const product = !item.hasAttribute('data-promo');
        if (product) count++;
        const hidden = !this.expanded && count > limit;
        item.hidden = hidden;
        if (hidden) item.style.setProperty('display', 'none', 'important');
        else item.style.removeProperty('display');
      });
      this.button.hidden = count <= limit && !this.dataset.next;
      this.button.querySelector('[data-toggle-label]').textContent = this.expanded ? this.dataset.less : this.dataset.more;
      this.button.setAttribute('aria-expanded', String(this.expanded));
      requestAnimationFrame(() => {
        if (!this.media.matches) return;
        const visible = Array.from(this.grid.children).filter(item => !item.hidden && getComputedStyle(item).display !== 'none');
        const last = visible[visible.length - 1];
        const previous = visible[visible.length - 2];
        if (last && previous && !last.hasAttribute('data-promo') && last.getBoundingClientRect().top > previous.getBoundingClientRect().top + 2) last.classList.add('amaris-grid-closing');
      });
    }
  });
}

if (!customElements.get('amaris-promo-layout')) {
  customElements.define('amaris-promo-layout', class extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => {
        const root = document.getElementById(this.dataset.root);
        this.grid = root && root.querySelector('[data-collection-products] .grid');
        if (!this.grid) return;
        this.promos = Array.from(this.grid.querySelectorAll(':scope > [data-promo]')).map(node => {
          const marker = document.createComment('promo');
          node.before(marker);
          return {node, marker};
        });
        this.media = matchMedia('(max-width:767px)');
        this.update = () => {
          this.promos.forEach(({node,marker}) => {
            marker.after(node);
            ['width','max-width','flex-basis'].forEach(key => node.style.removeProperty(key));
          });
          if (this.media.matches) {
            const products = Array.from(this.grid.children).filter(node => !node.hasAttribute('data-promo'));
            this.promos.slice().reverse().forEach(({node}) => {
              const content = node.querySelector('[data-promo-mobile-position]');
              if (!content) return;
              const position = Number(content.dataset.promoMobilePosition);
              if (position > 0 && products[position - 1]) products[position - 1].before(node);
              const width = content.dataset.promoMobileWidth;
              if (width && width !== 'inherit') {
                ['width','max-width','flex-basis'].forEach(key => node.style.setProperty(key, width + '%', 'important'));
              }
            });
          }
          const toggle = root.querySelector('amaris-collection-toggle');
          if (toggle && typeof toggle.update === 'function') toggle.update();
        };
        this.update();
        this.media.addEventListener('change', this.update);
      });
    }
    disconnectedCallback() {
      if (this.media && this.update) this.media.removeEventListener('change', this.update);
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
